<template>
    <div>
        <draggable
            v-model="props.data.contents"
            handle=".handle"
            item-key="unique_id"
            :animation="150"
        >
            <template #item="{ element: content }">
                <draggable-accordion
                    class="mb-2"
                    :unique_id="content.unique_id"
                    :edit="content.edit"
                    @remove="removeContent"
                    @toggle="toggleContent(content)"
                >
                    <template #title>{{ contentName }}</template>
                    <template #content>
                        <div class="grid lg:grid-cols-2 gap-6 gap-y-4">
                            <div class="col-span-2">
                                <text-field
                                    label="Question"
                                    v-model="content.question"
                                />
                            </div>
                            <div class="col-span-2">
                                <label
                                    class="flex justify-between items-center mb-1.5 text-sm">
                                    Answer
                                </label>

                                <text-editor
                                    :text="content.answer"
                                    @input="(newValue) => { content.answer = newValue }"
                                />
                            </div>
                        </div>
                    </template>
                </draggable-accordion>
            </template>
        </draggable>

        <btn type="secondary" size="small" icon-name="add-circle" @click="addContent">Add {{ contentName }}</btn>

        <div class="flex justify-between items-center mt-4">
            <toggle
                name="first_item_open"
                size="medium"
                v-model="props.data.first_item_open"
            />
            <span class="flex flex-col flex-grow">
                <span class="text-sm font-medium">First item open by default</span>
            </span>
        </div>
    </div>
</template>

<script setup>
import {defineProps} from 'vue';
import draggable from 'vuedraggable';
import {uniqueId} from '../helpers';

const contentName = 'FAQ';

const props = defineProps({
    data: Object
});

props.data.contents = props.data?.contents ?? [];

props.data.contents.forEach(content => {
    if (!content.unique_id) {
        content.unique_id = uniqueId();
    }
});

// Ensure only one content is open at initialization
let foundFirstOpen = false;
props.data.contents.forEach(content => {
    if (content.edit) {
        if (foundFirstOpen) {
            content.edit = false;
        } else {
            foundFirstOpen = true;
        }
    }
});

const toggleContent = (element) => {
    const isOpening = !element.edit;
    if (isOpening) {
        props.data.contents.forEach(content => {
            if (content.unique_id !== element.unique_id) {
                content.edit = false;
            }
        });
    }
    element.edit = !element.edit;
}

const addContent = () => {
    // Close all existing content
    props.data.contents.forEach(content => {
        content.edit = false;
    });

    props.data.contents.push({
        unique_id: uniqueId(),
        edit: true,
        question: '',
        answer: '',
    });
}

const removeContent = (uniqueId) => {
    props.data.contents.splice(
        props.data.contents.findIndex(content => content.unique_id === uniqueId)
    , 1);
}
</script>
